module.exports = __webpack_public_path__ + "static/media/queue.a8cdc187.svg";